import nacl from 'tweetnacl';
import { decodeBase64, encodeBase64, decodeUTF8 } from 'tweetnacl-util';
import type { FormResponsePlaintext, EncryptedFormPayload } from '../types/forms';

/** NaCl box from a throwaway key, so only the holder of the recipient's private key can open it. */
export function encryptToPublicKey(
  plaintext: unknown,
  recipientPublicKeyB64: string,
): EncryptedFormPayload {
  const recipientPublicKey = decodeBase64(recipientPublicKeyB64);
  const ephemeralKeypair = nacl.box.keyPair();
  const nonce = nacl.randomBytes(nacl.box.nonceLength);
  const messageBytes = decodeUTF8(JSON.stringify(plaintext));

  const ciphertext = nacl.box(
    messageBytes,
    nonce,
    recipientPublicKey,
    ephemeralKeypair.secretKey,
  );

  if (!ciphertext) {
    throw new Error('Encryption failed');
  }

  return {
    ciphertextB64: encodeBase64(ciphertext),
    nonceB64: encodeBase64(nonce),
    ephemeralPublicKeyB64: encodeBase64(ephemeralKeypair.publicKey),
  };
}

export function encryptFormResponse(
  plaintext: FormResponsePlaintext,
  recipientPublicKeyB64: string,
): EncryptedFormPayload {
  return encryptToPublicKey(plaintext, recipientPublicKeyB64);
}
